<script setup lang="tsx">
import { getCSSVar } from "@zyzgroup/core-web";

const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {
    color: getCSSVar("--xg-blue")
  }
);

const rectStyle = { backgroundColor: props.color };
</script>

<template>
  <div class="loading-1">
    <div
      class="rect1"
      :style="rectStyle"
    ></div>
    <div
      class="rect2"
      :style="rectStyle"
    ></div>
    <div
      class="rect3"
      :style="rectStyle"
    ></div>
    <div
      class="rect4"
      :style="rectStyle"
    ></div>
    <div
      class="rect5"
      :style="rectStyle"
    ></div>
  </div>
</template>

<style scoped>
.loading-1 {
  position: relative;
  display: block;
  overflow: hidden;
  width: 100%;
  height: 100%;
  text-align: center;
}

.loading-1 > div {
  width: 6px;
  height: 100%;
  margin: auto 2px;
  display: inline-block;
  animation: stretchdelay 1.2s infinite ease-in-out;
}

.loading-1 .rect2 {
  animation-delay: -1.1s;
}

.loading-1 .rect3 {
  animation-delay: -1s;
}

.loading-1 .rect4 {
  animation-delay: -0.9s;
}

.loading-1 .rect5 {
  animation-delay: -0.8s;
}

@keyframes stretchdelay {
  0%,
  40%,
  100% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
}
</style>
